import type { Ref } from 'vue'
import type {
  DirectUploadDocument,
  ExistingDocument,
} from '@app/shared/types/sf-data'
import type * as PastApi from '@app/application/client_meetings/api/past'

export interface PreparePageData {
  clientMeetingId: number
  initialOrder: string[]
  links: Link[]
  reports: Report[]
  availableReports: AvailableReport[]
  externalNotes: ExternalNote[]
  maxExternalNotes: number
  pastedNotes: string
  suggestionsEnabled: boolean
  companyHasPendingProposal: boolean
  suggestions: string[] | null
}

export interface PresentPageData {
  clientMeetingId: number
  initialOrder: string[]
  links: Link[]
  reports: Report[]
  pinnedReportsEnabled: boolean
  pinnedReportsCount: number
}

export interface PastPageData {
  messageBus: {
    channelName: string
    lastId: number
  }
  meetings: PastApi.Meeting[]
  ledgerLabel: string
}

export interface UseExportParams {
  meetingId: number
}

export interface UseExportReturn {
  exportInProgress: Ref<boolean>
  generateExport: () => Promise<{ url: string } | void | null>
}

export type Link = {
  id: number
  title: string
  url: string
  presentable?: boolean
}

export type Report = {
  id: number
  title: string
  url: string
  removable: boolean
  meetingReportId?: number
  presentable?: boolean
}

export type AvailableReport = {
  id: number
  title: string
}

export type Attachment = {
  id: number
  filename: string
  url: string
}

export type Meeting = {
  id: number
  title: string
  summary: string | null
  summaryGenerating: boolean
  completedAt: string
  order: string[]
  reports?: Report[]
  links: Link[]
  proposalId: number | null
  discussedTodoIds: number[]
  attachments: Attachment[]
}

export interface RemarksByLedger {
  [key: number]: number[]
}

export type AccountRemarks = RemarksByLedger
export type ReportElementRemarks = RemarksByLedger

export type ProposalDetails = {
  followUpActions: string[]
  replies: {
    message: string
    talkingPointId: number
  }[]
}

export type Proposal = {
  id: number
  status: ProposalStatus
  details: ProposalDetails | null
}

export enum ProposalStatus {
  Generating = 'generating',
  Failed = 'failed',
  Pending = 'pending',
  Accepted = 'accepted',
  Rejected = 'rejected',
}

export type ExternalNote = {
  id: number
  name: string
  uploadedBy: string
  size: number
}

export type ExternalNoteUploaderItem = DirectUploadDocument | ExistingDocument

export type TodoModalData = {
  text: string
  todoIndex: number
}
